import { createWidget } from '@funtech-int/rival';

import { BackgroundPlayerProps } from './components/BackgroundPlayer/BackgroundPlayer';

export const backgroundPlayerWidget = createWidget<unknown, BackgroundPlayerProps>();
